import Vue from "vue";
import VueRouter from "vue-router";
import Index from "../views/homePage/index/Index.vue";
import HomeView from "../views/HomeView.vue";
import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    redirect: "/index",
    children: [
      {
        path: "/index",
        name: "index",
        component: Index,
        meta: {
          metaInfo: {
            title: "私存心动|私存心动官网",
            keywords: "私存心动,私存心动官网",
            description:
              "一款主打“自由、随心”聊天交友的软件平台，高颜值的人都在用，能快速满足“同城处CP、陌生人交朋友”的社交娱乐需求。",
          },
        },
      },
      {
        path: "/about",
        name: "about",
        component: () => import("@/views/homePage/About.vue"),
        meta: {
          metaInfo: {
            title: "关于我们",
            keywords: "欢迎更多，爱社交，爱游戏，爱旅游，爱收集，密友们加入",
            description:
              "在私存心动可以跟慕恋的女生投递爱意、跟久未联系的好友叙旧追忆、跟游戏的战友连线配合等，还有更多陌生人交友功能等你来发现。",
          },
        },
      },
      {
        path: "/features",
        name: "features",
        component: () => import("@/views/homePage/Features.vue"),
        meta: {
          metaInfo: {
            title: "软件介绍",
            keywords: "私密畅聊，声控交友，群聊派对",
            description:
              "一群有趣的人在这里等你，和志同道合的朋友在派对里尽情狂欢，帮助你快速结交新朋友。声入人心，用声音认识新朋友，喜欢谁的声音用接唱开启对话，越玩越会爱上陌“声”人。我们贴心为你保护隐身，和相似的人聊有趣的事，不怕尬场，尽情交流兴趣与观点吧。",
          },
        },
      },
      {
        path: "/contact",
        name: "contact",
        component: () => import("@/views/homePage/Contact.vue"),
        meta: {
          metaInfo: {
            title: "联系我们",
            keywords: "欢迎更多，爱社交，爱游戏，爱旅游，爱收集，密友们加入",
            description:
              "在私存心动可以跟慕恋的女生投递爱意、跟久未联系的好友叙旧追忆、跟游戏的战友连线配合等，还有更多陌生人交友功能等你来发现。",
          },
        },
      },
      {
        path: "/privacy_protocol",
        name: "privacy_protocol",
        component: () => import("@/views/homePage/protocol/privacy_protocol.vue"),
        meta: {
          metaInfo: {
            title: "隐私协议",
            keywords: "欢迎更多，爱社交，爱游戏，爱旅游，爱收集，密友们加入",
            description:
              "在私存心动可以跟慕恋的女生投递爱意、跟久未联系的好友叙旧追忆、跟游戏的战友连线配合等，还有更多陌生人交友功能等你来发现。",
          },
        },
      },
      {
        path: "/user_protocol",
        name: "user_protocol",
        component: () => import("@/views/homePage/protocol/user_protocol.vue"),
        meta: {
          metaInfo: {
            title: "用户协议",
            keywords: "欢迎更多，爱社交，爱游戏，爱旅游，爱收集，密友们加入",
            description:
              "在私存心动可以跟慕恋的女生投递爱意、跟久未联系的好友叙旧追忆、跟游戏的战友连线配合等，还有更多陌生人交友功能等你来发现。",
          },
        },
      },
    ],
  },
  {
    path: "/protocol",
    name: "protocol",
    redirect: "/protocol/myxq_perms",
    component: () => import("@/views/ProtocolView.vue"),
    children: [
      {
        path: "myxq_perms",
        name: "myxq_perms",
        component: () => import("@/views/homePage/protocol/MyxqPerms.vue"),
      },
      {
        path: "myxq_pro",
        name: "myxq_pro",
        component: () => import("@/views/homePage/protocol/MyxqPro.vue"),
      },
    ],
  },
];
const originalPush = VueRouter.prototype.push;
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

// 全局前置守卫
router.beforeEach((to, from, next) => {
  if (to.meta.metaInfo) {
    store.dispatch("metaModule/changeMetaInfo", to.meta.metaInfo);
  }
  next();
});

export default router;
